export default {
    authRecommendedVideos: null,
    authMoodForSomethingElse: null,
    authRecentlyWatchedVideos: null,
    authCareerVideos: null,
    authMindbodyVideos: null,
    authInspirationVideos: null,
    authWorkVideos: null,
    authMoneyVideos: null,
    authLifeVideos: null,
    authQuestions: null,
    authUserVideos: null,
    authUserFavVideos: null,
    authRelatedVideos: null,
    authQuote: null,
    authGreeting: null,
    authFunnies: null,
    toneTeasers: null,
    toneTakeaways: null
}



// WEBPACK FOOTER //
// ./src/store/authpage/state.js